module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/template-compiler?{"id":"data-v-1edc1b98"}!D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 523
// module chunks = 0